import View from "../common/components/WishlistButton";
import components from "./components.js";
components.define("js-wishlist-button", View);